import './Select.scss';
import Component from './Select.js';
export default Component;
